import { Tooltip, IconButton } from 'components/mui';
import { SearchIcon, CloseOutlinedIcon } from 'components/icons';
import { Search, SearchIconWrapper, StyledInputBase } from 'components';

const ChecklistSearch = ({ searchInput, setSearchInput }) => {
	const onChange = (e) => {
		const _input = e.target.value;
		setSearchInput(_input);
	};

	return (
		<Search>
			<SearchIconWrapper>
				<SearchIcon />
			</SearchIconWrapper>
			<StyledInputBase
				placeholder="Search…"
				value={searchInput}
				onChange={onChange}
				endAdornment={
					<Tooltip title="Clear">
						<IconButton onClick={() => setSearchInput('')}>
							<CloseOutlinedIcon />
						</IconButton>
					</Tooltip>
				}
			/>
		</Search>
	);
};

export default ChecklistSearch;
